(function ($) {
    $(document).ready(function () {
        $('.logos-section-cards.slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 4000,
            cssEase: 'linear',
            arrows: false,
            dots: false,
            variableWidth: true,
        });
    });
})(jQuery);